import { render, staticRenderFns } from "./ErrorsMessageDialog.vue?vue&type=template&id=19ef0b9a&"
import script from "./ErrorsMessageDialog.vue?vue&type=script&lang=js&"
export * from "./ErrorsMessageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports